import ApiClient from './ApiClient';
/* global axios */

class TelegramBotAPI extends ApiClient {
  constructor() {
    super('telegram_bot', { accountScoped: true });
  }

  getStatus(accountId) {
    return axios.get(`${this.baseUrl()}/telegram_bot/status?account_id=${accountId}`);
  }

  connect() {
    return axios.post(`${this.baseUrl()}/telegram_bot/connect`);
  }

  disconnect() {
    return axios.post(`${this.baseUrl()}/telegram_bot/disconnect`);
  }
}

export default new TelegramBotAPI(); 